import { useEffect, useRef, useState } from "react";

export const BOND_DICE_RESULT_DWELL_MS = 5000;

/**
 * Shows a settled dice round briefly, then clears the stage for the next ticket.
 */
export function useBondDiceResultDwell(settledRound, { dwellMs = BOND_DICE_RESULT_DWELL_MS, onCleared } = {}) {
  const [displayRound, setDisplayRound] = useState(null);
  const dismissedRef = useRef(new Set());
  const timerRef = useRef(null);

  useEffect(() => {
    window.clearTimeout(timerRef.current);

    if (settledRound?.outcome == null) {
      setDisplayRound(null);
      return undefined;
    }

    const id = String(settledRound._id || settledRound.id || "");
    if (!id || dismissedRef.current.has(id)) {
      setDisplayRound(null);
      return undefined;
    }

    setDisplayRound(settledRound);
    timerRef.current = window.setTimeout(() => {
      dismissedRef.current.add(id);
      setDisplayRound(null);
      onCleared?.();
    }, dwellMs);

    return () => window.clearTimeout(timerRef.current);
  }, [settledRound, dwellMs, onCleared]);

  return displayRound;
}

export default useBondDiceResultDwell;
